import { graphql } from "relay-runtime"

export const deUpdatePatientSocialHistoryMutation = graphql`
  mutation deUpdatePatientSocialHistoryMutation($input: De_updatePatientSocialHistoryInput!) {
    updatePatientSocialHistory: de_updatePatientSocialHistory(input: $input) {
      errors {
        ... on Error {
          message
        }
        ... on PatientNotFound {
          patientId
          message
        }
      }
      socialHistory {
        ...SocialHistoryFragment
      }
    }
  }
`
